$(document).ready(function() {
    $('.leave-rating .fa-star').on('click', function() {
        // Workaround for a Listeo bug.
        var val = 6 - $('#' + $(this).attr('for')).val();
        $('input[name="stars"]').val(val);
    });
});
